import { z } from 'zod';
import { BOM_CONSTRAINTS } from './constraints.js';
import { checkBomIdentityRequiredOnCreate, checkBomWarehousesRequiredOnCreate } from './rules.js';
import { bomFormFieldsSchema } from './update-form.js';
export const bomNumSchema = z
    .string()
    .trim()
    .min(1, `${BOM_CONSTRAINTS.num.label} is required.`)
    .max(BOM_CONSTRAINTS.num.maxLength, `${BOM_CONSTRAINTS.num.label} must be ${BOM_CONSTRAINTS.num.maxLength} characters or fewer.`);
export const bomDescriptionSchema = z
    .string()
    .trim()
    .min(1, `${BOM_CONSTRAINTS.description.label} is required.`)
    .max(BOM_CONSTRAINTS.description.maxLength, `${BOM_CONSTRAINTS.description.label} must be ${BOM_CONSTRAINTS.description.maxLength} characters or fewer.`);
export const bomNoteSchema = z
    .string()
    .trim()
    .max(BOM_CONSTRAINTS.note.maxLength, `${BOM_CONSTRAINTS.note.label} must be ${BOM_CONSTRAINTS.note.maxLength} characters or fewer.`)
    .nullable()
    .optional();
// Not in the create/edit forms yet, but the GraphQL field is still live so create/update-input.ts still validate it.
export const bomUrlSchema = z
    .string()
    .trim()
    .max(BOM_CONSTRAINTS.url.maxLength, `${BOM_CONSTRAINTS.url.label} must be ${BOM_CONSTRAINTS.url.maxLength} characters or fewer.`)
    .refine((value) => value === '' || /^https?:\/\//i.test(value), `${BOM_CONSTRAINTS.url.label} must start with http:// or https://.`)
    .optional();
// brandId's blank-on-create check lives in checkBomIdentityRequiredOnCreate alongside num and
// description; the base schema's optionalUuidString still catches a malformed (non-blank) value.
// The Output floor is not checked here: the wizard owns the Items UI, so validateRecipeStep gates it.
export const bomCreateFormSchema = bomFormFieldsSchema.superRefine((values, context) => {
    const issues = [
        ...checkBomIdentityRequiredOnCreate(values),
        ...checkBomWarehousesRequiredOnCreate(values),
    ];
    for (const issue of issues) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
});
//# sourceMappingURL=create-form.js.map